export const VALID_CODE_LENGTH = 6 // 验证码长度

// 浮层约定：van-popup 不要写死 z-index（会把 Vant 全局计数重置，后开的层反而被盖住）
// Tabbar 2000 → 页面弹层自增 2000+ → 数字键盘 3000 → 自定义阻断弹窗 5000
export const Z_INDEX_KEYBOARD = 3000
export const Z_INDEX_MODAL = 5000



// WEBPACK FOOTER //
// ./src/utils/constants.js